var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classnames from 'classnames';
import { ProgressTrackerStep } from './ProgressTrackerStep';
import { ProgressTrackerDivider } from './ProgressTrackerDivider';
export const ProgressTracker = (_a) => {
    var { children, className, completed, currentIndex = 0, disabled, hideLabels, size = 'medium' } = _a, rest = __rest(_a, ["children", "className", "completed", "currentIndex", "disabled", "hideLabels", "size"]);
    const renderSteps = () => {
        return React.Children.map(children, (child, index) => {
            const childProps = {
                key: `${index}-step`,
                stepNumber: index + 1,
                active: child.props.active,
                completed: child.props.completed,
                editing: child.props.editing,
                hideLabels: child.props.hideLabels,
                size,
            };
            const isIndexed = currentIndex !== false;
            const isActive = index === currentIndex;
            const isBeforeActive = index < currentIndex;
            const flowPreviouslyCompleted = completed;
            if (hideLabels)
                childProps.hideLabels = true;
            if (isIndexed) {
                if (flowPreviouslyCompleted) {
                    // If currentIndex is used and this is the current step
                    if (isActive)
                        childProps.editing = true;
                    // If currentIndex is used and this step is not the active step and this flow has been previously completed
                    if (!isActive)
                        childProps.completed = true;
                }
                if (!flowPreviouslyCompleted) {
                    // If currentIndex is used and this is the current step
                    if (isActive)
                        childProps.active = true;
                    // If currentIndex is used and this step is before the current step
                    if (isBeforeActive)
                        childProps.completed = true;
                }
            }
            return [
                index > 0 && (React.createElement(ProgressTrackerDivider, { key: `${index}-divider`, completed: isBeforeActive ||
                        flowPreviouslyCompleted ||
                        isActive })),
                React.cloneElement(child, childProps),
            ];
        });
    };
    const ProgressTrackerClasses = classnames('ProgressTracker', className, {
        'ProgressTracker--completed': completed,
        'ProgressTracker--disabled': disabled,
        [`ProgressTracker--${size}`]: size,
    });
    return (React.createElement("div", Object.assign({ className: ProgressTrackerClasses, "data-anvil-component": "ProgressTracker" }, rest), renderSteps()));
};
ProgressTracker.Step = ProgressTrackerStep;
ProgressTracker.Divider = ProgressTrackerDivider;
//# sourceMappingURL=ProgressTracker.js.map